<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @submit.prevent="load" @keyup.enter="load">
                    <b-col cols="3">
                        <lg-form-input id="myInput" class="input" description="" type="number"
                            v-model="form.numTombamento" label="Tombamento" @input="limitarQuantidade()"
                            @blur="peyTabPress()" />
                    </b-col>
                    <b-col cols="3">
                        <lg-form-input description="" v-model="form.numeroSerie" label="Nº serie" />
                    </b-col>

                    <b-col cols="3">
                        <lg-form-input description="" v-model="form.numTombaSamp" label="Tombamento SAMP"
                            type="number" />
                    </b-col>
                    <b-col cols="3">
                        <lg-form-const-select label="Situação:" v-model="form.situacao"
                            :options="form.optionsFilterSituacao" />
                    </b-col>

                    <b-col cols="12" class="d-flex justify-content-end align-items-center flex-wrap mt-3">
                        <div class="d-flex align-items-center mr-3">
                            <img v-b-tooltip.hover.top="'Gerar Relatorio XLS Carga Patrimonial'"
                                @click="gerarRelatorioGeralXlsx()" :src="xlsIcon" class="img img--clickable mr-1" alt="XLSX" />

                            <img v-b-tooltip.hover.top="'Gerar Relatorio PDF Carga Patrimonial'"
                                @click="gerarRelatorioGeralPdf()" :src="pdf" class="img img--clickable" alt="PDF" />
                        </div>
                        <div class="d-flex align-items-center mr-3">
                            <img v-b-tooltip.hover.top="'Gerar Relatorio XLS Carga Patrimonial Detalhada'"
                                @click="gerarRelatorioGeralXlsxDetalhada()" :src="xlsIcon" class="img img--clickable mr-1"
                                alt="XLSX" />
                            <img v-b-tooltip.hover.top="'Gerar Relatorio PDF Carga Patrimonial Detalhada'"
                                @click="gerarRelatorioGeralPdfDetalhada()" :src="pdf" class="img img--clickable" alt="PDF" />
                        </div>
                        <div class="d-flex align-items-center">
                            <img @click="gerarRelatorioGeralXlsxDadosCadastrais()" :src="xlsIcon" class="img img--clickable mr-1"
                                alt="XLSX"
                                v-b-tooltip.hover.top="'Gerar Relatorio XLS Dados Cadastrais Carga Patrimonial'" />
                            <img v-b-tooltip.hover.top="'Gerar Relatorio PDF Dados Cadastrais Carga Patrimonial'"
                                @click="gerarRelatorioGeralPdfDadosCadastrais()" :src="pdf" class="img img--clickable" alt="PDF" />
                        </div>
                        <b-button @click="clear" id="limpar" size="sm" pill variant="primary" class="mx-1"
                            style="height: 40px">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limpar" title="Limpar" />
                        </b-button>
                        <!-- Buscar -->
                        <b-button @click="load" id="localizar" size="sm" pill variant="primary" class="mx-1"
                            style="height: 40px">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizar" title="Localizar" />
                        </b-button>


                    </b-col>
                </b-form-row>
                <!-- Tabela de resultados -->
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template v-slot:cell(relacionado)="{ item }">
                        <span>{{ item.relacionado === 1 ? "Sim" : "Não" }}</span>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(bloqueado)="{ item }">
                        <b-button class="text-danger p-0 mx-1" variant="link" title="Item Bloqueado"
                            v-if="item.bloqueado === 1">
                            <b-icon icon="dash-circle-fill" />
                        </b-button>
                    </template>
                    <template v-slot:cell(action)="{ item }">
                        <b-button v-if="temPrivilegioVisualizar()" id="visualizar" size="sm" pill variant="primary"
                            @click="visualizarItemBemPermanente(item)">
                            <b-icon icon="file-earmark-slides" />
                            <b-tooltip target="visualizar" title="Visualizar"></b-tooltip>
                        </b-button>
                    </template>
                </b-table>
            </b-card>

        </b-card-body>

        <b-card>
            <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
                        totalPage }} -
                        {{ total }} registros</b-col>
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                        <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                            :options="perPageOptions">
                        </b-form-select>
                    </b-col>
                </b-col>
                <b-col cols="6">
                    <div class="d-flex justify-content-end align-items-end">
                        <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                            :total-rows="total"></b-pagination>
                    </div>
                </b-col>
            </b-row>
        </b-card>

        <ModalItemBemPermanenteView @fecharModal="cancelar" :prefix="title + ' > '" v-if="mostrarModal"
            :id="id">
        </ModalItemBemPermanenteView>
    </b-card>
</template>

<script>
import IBPService from "@/core/api/IBPService"
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ModalItemBemPermanenteView from "@/core/components/Modals/ModalItemBemPermanenteView.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import PdfIcon from "@/core/assets/icons/pdf.png";
import xlsIcon from "@/core/assets/icons/xls.png";
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil";

export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
        ModalItemBemPermanenteView
    },
    mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],
    props: {
        title: { type: String, default: "Consulta Item Bem Permanente" }
    },
    data() {
        return {
            params: {},
            id: null,
            perPage: 10,
            mostrarModal: false,
            perPageOptions: [10, 25, 50, 100],
            form: {
                status: { id: 1, descricao: "Todos" },
                numeroSerie: "",
                numTombamento: "",
                numTombaSamp: "",
                input: "",
                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: -1 },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },
            pdf: PdfIcon,
            xlsIcon: xlsIcon
        };
    },

    async beforeMount() {
        this.$statusService = new ResourceService(`/api/status/tipo/42`);
        this.$service = new ResourceService(`/api/consultaitembempermanente`);
        this.$ibpService = new IBPService();
        this.busy = false;
        var { data } = await new ResourceService("/api/configuracoes-sistema").get('113');

        this.quantidadeAlgorismo = data.valorPropriedade == null || data.valorPropriedade == ""?8:data.valorPropriedade;

        console.log(data);
    },

    watch: {
        page() {
            this.load();
        },

        "form.numeroSerie"() {
            if (this.form.numeroSerie === undefined || this.form.numeroSerie === "") {
                this.records = [];
            }
        },

        "form.numTombaSamp"() {
            if (
                this.form.numTombaSamp === undefined ||
                this.form.numTombaSamp === ""
            ) {
                this.records = [];
            }
        },

        "form.numTombamento"() {
            if (
                this.form.numTombamento === undefined ||
                this.form.numTombamento === ""
            ) {
                this.records = [];
            }
        },

        "form.situacao"() {
            if (this.form.situacao === undefined || this.form.situacao === "") {
                this.records = [];
            }
        },
    },

    computed: {
        tableFields() {
            return [
                {
                    key: "bloqueado",
                    label: "",
                },

                {
                    key: "numTombamento",
                    label: "Tombamento",
                    thClass: "text-left",
                    tdClass: "text-left",
                    thStyle: "padding-left: 0px",

                },

                {
                    key: "s_numTombAntigo",
                    label: "Tombamento Samp",
                    thClass: "text-left",
                    tdClass: "text-left",
                    thStyle: "padding-left: 0px",

                },

                {
                    key: "itemRegEntrada.produto.numero",
                    label: "Número",
                    thClass: "text-left",
                    tdClass: "text-left",
                    thStyle: "padding-left: 0px",

                },
                {
                    key: "itemRegEntrada.produto.descricaoResumida",
                    label: "Descrição",
                    thClass: "text-left",
                    tdClass: "text-left",
                    thStyle: "padding-left: 0px",

                },

                {
                    key: "relacionado",
                    label: "BR",
                    thClass: "text-center",
                    tdClass: "text-center",
                    thStyle: "padding-left: 0px",

                },

                {
                    key: "valorOriginal",
                    label: "Valor Aquisição",
                    thClass: "text-right",
                    tdClass: "text-right",
                    thStyle: "padding-left: 0px",

                    formatter: (value) => {
                        return value.toLocaleString("pt-BR", {
                            style: "decimal",
                            currency: "BRL",
                            minimumFractionDigits: 2,
                        });
                    },
                },

                {
                    key: "action",
                    label: "",
                    tdClass: "text-center",


                },
            ];
        },

    },
    methods: {
        temPrivilegioVisualizar() {
            return verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_PERMANENTE_VISUALIZAR);

        },
        filtrosNaoPreenchidos() {
            return !this.form.numTombamento && !this.form.numTombaSamp && !this.form.numeroSerie
        },


        warningFiltroObrigatorio() {
            this.$notify({
                type: "warning",
                message: `É obrigatório o preenchimento de pelo menos um destes filtros: "Tombamento", "Tombamento SAMP" ou "Nº Série"`,
                timeout: 3000,
            });
        },
        cancelar() {
            this.mostrarModal = false;
        },
        async load() {
            if (this.filtrosNaoPreenchidos()) {
                this.warningFiltroObrigatorio();
                return;
            }

            this.peyTabPress();
            this.params = {};
            this.params.numSerie = null;
            if (this.form.numeroSerie != undefined && this.form.numeroSerie != "") {
                this.params.numSerie = this.form.numeroSerie;
            }


            this.params.numTomb = null;
            if (this.form.numTombamento) {
                this.params.numTomb = this.form.numTombamento;
            }

            this.params.numTombaSamp = null;
            if (
                this.form.numTombaSamp != undefined &&
                this.form.numTombaSamp != ""
            ) {
                this.params.numTombaSamp = this.form.numTombaSamp;
            }

            this.params.situacao = null;
            if (!this.form.situacao != -1) {
                this.params.situacao = this.form.situacao;
            }


            this.params.perPage = this.perPage;
            this.params.page = this.page;

            this.busy = true;
            let vm = this;
            this.params.departamentoId = JSON.parse(localStorage.getItem("context")).departamento.id;

            this.$ibpService.getPageConsultaIBP(this.params).then((response) => {
                vm.busy = false;
                vm.records = response.data.content;
            });
        },
        async gerarRelatorioGeralPdf() {
            if (this.filtrosNaoPreenchidos()) {
                this.warningFiltroObrigatorio();
                return;
            }
            this.param = {};
            if (this.form.numTombamento) {
                this.param.numTomb = this.form.numTombamento;
            }
            if (this.form.numTombaSamp) {
                this.param.numTombSamp = this.form.numTombaSamp;
            }
            if (this.form.numSerie) {
                this.param.numSerie = this.form.numSerie;
            }

            if (this.form.situacao != null) {
                this.param.situacao = this.form.situacao;
            }

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-carga-patrimonial-item-bem-permanente');
                const { data } = await resource.getWithParams('PDF', this.param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: `Erro ao gerar relatório. Tente novamente mais tarde.`,
                    timeout: 3000,
                });
            } finally {
                this.busy = false;
            }
        },
        async gerarRelatorioGeralPdfDetalhada() {
            if (this.filtrosNaoPreenchidos()) {
                this.warningFiltroObrigatorio();
                return;
            }
            this.param = {};
            if (this.form.numTombamento) {
                this.param.numTomb = this.form.numTombamento;
            }
            if (this.form.numTombaSamp) {
                this.param.numTombSamp = this.form.numTombaSamp;
            }
            if (this.form.numSerie) {
                this.param.numSerie = this.form.numSerie;
            }

            if (this.form.situacao != null) {
                this.param.situacao = this.form.situacao;
            }

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-carga-patrimonial-detalhada-item-bem-permanente');
                const { data } = await resource.getWithParams('PDF', this.param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: `Erro ao gerar relatório. Tente novamente mais tarde.`,
                    timeout: 3000,
                });
            } finally {
                this.busy = false;
            }
        },
        async gerarRelatorioGeralPdfDadosCadastrais() {
            if (this.filtrosNaoPreenchidos()) {
                this.warningFiltroObrigatorio();
                return;
            }
            this.param = {};
            if (this.form.numTombamento) {
                this.param.numTomb = this.form.numTombamento;
            }
            if (this.form.numTombaSamp) {
                this.param.numTombSamp = this.form.numTombaSamp;
            }
            if (this.form.numSerie) {
                this.param.numSerie = this.form.numSerie;
            }

            if (this.form.situacao != null) {
                this.param.situacao = this.form.situacao;
            }

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-dados-cadastrais-carga-patrimonial-item-bem-permanente');
                const { data } = await resource.getWithParams('PDF', this.param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: `Erro ao gerar relatório. Tente novamente mais tarde.`,
                    timeout: 3000,
                });
            } finally {
                this.busy = false;
            }
        },
        async gerarRelatorioGeralXlsx() {
            if (this.filtrosNaoPreenchidos()) {
                this.warningFiltroObrigatorio();
                return;
            }
            this.param = {};
            if (this.form.numTombamento) {
                this.param.numTomb = this.form.numTombamento;
            }
            if (this.form.numTombaSamp) {
                this.param.numTombSamp = this.form.numTombaSamp;
            }
            if (this.form.numSerie) {
                this.param.numSerie = this.form.numSerie;
            }

            if (this.form.situacao != null) {
                this.param.situacao = this.form.situacao;
            }

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-carga-patrimonial-item-bem-permanente');
                const { data } = await resource.getWithParams('EXCEL', this.param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: `Erro ao gerar relatório. Tente novamente mais tarde.`,
                    timeout: 3000,
                });
            } finally {
                this.busy = false;
            }
        },
        async gerarRelatorioGeralXlsxDetalhada() {
            if (this.filtrosNaoPreenchidos()) {
                this.warningFiltroObrigatorio();
                return;
            }
            this.param = {};
            if (this.form.numTombamento) {
                this.param.numTomb = this.form.numTombamento;
            }
            if (this.form.numTombaSamp) {
                this.param.numTombSamp = this.form.numTombaSamp;
            }
            if (this.form.numSerie) {
                this.param.numSerie = this.form.numSerie;
            }

            if (this.form.situacao != null) {
                this.param.situacao = this.form.situacao;
            }

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-carga-patrimonial-detalhada-item-bem-permanente');
                const { data } = await resource.getWithParams('EXCEL', this.param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: `Erro ao gerar relatório. Tente novamente mais tarde.`,
                    timeout: 3000,
                });
            } finally {
                this.busy = false;
            }
        },
        async gerarRelatorioGeralXlsxDadosCadastrais() {
            if (this.filtrosNaoPreenchidos()) {
                this.warningFiltroObrigatorio();
                return;
            }
            this.param = {};
            if (this.form.numTombamento) {
                this.param.numTomb = this.form.numTombamento;
            }
            if (this.form.numTombaSamp) {
                this.param.numTombSamp = this.form.numTombaSamp;
            }
            if (this.form.numSerie) {
                this.param.numSerie = this.form.numSerie;
            }

            if (this.form.situacao != null) {
                this.param.situacao = this.form.situacao;
            }

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-dados-cadastrais-carga-patrimonial-item-bem-permanente');
                const { data } = await resource.getWithParams('EXCEL', this.param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: `Erro ao gerar relatório. Tente novamente mais tarde.`,
                    timeout: 3000,
                });
            } finally {
                this.busy = false;
            }
        },
        clear() {
            this.form.situacao = 1;
            this.form.numeroSerie = null;
            this.form.numTombamento = null;
            this.form.numTombaSamp = null;
            this.params = {}
        },

        async visualizarItemBemPermanente(item) {
            this.id = item.id;
            this.mostrarModal = true;
        },

        async statusList({ filter, page = 1 }) {
            return this.$statusService.findAll({ filter, page, limit: 5 });
        },


        async limitarQuantidade() {
            const maxCaracteres = this.quantidadeAlgorismo;
            if (this.form.numTombamento.toString().length > maxCaracteres) {
                this.form.numTombamento = parseInt(
                    this.form.numTombamento.toString().slice(1, maxCaracteres)
                );
            }
        },

        async peyTabPress() {
            if (this.form.numTombamento.length > 0 && this.form.numTombamento.length < this.quantidadeAlgorismo)
                this.form.numTombamento = this.form.numTombamento.padStart(this.quantidadeAlgorismo, '0');
        },

    },
};
</script>
